import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType, getChildEdgeTypeId, getZombieInstanceFromPrimaryKey, } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { useParams } from 'react-router-dom';
import { useTypedSearchParams } from '../hooks/useTypedSearchParams';
import { ObjectViewType } from '../types/AppTypes';
import { ObjectHeader } from '../v2/components/generic/ObjectView/ObjectHeader';
import { getViewDefintionFromObject } from './factories/AttributeDefinitions';
import { ListerlizerAdapter } from './factories/Listerlizer/legacy/ListerlizerAdapter';
const debug = process.env.REACT_APP_DEBUG && false;
const DefaultThingsView = (props) => {
    const { contextCustomer, transactionFunctions, userFunctions, constrainedParameters } = props;
    debug && console.log('DefaultThingsView props v3', props);
    const params = useParams();
    const typeByLocation = params.type;
    const objectTypeId = (constrainedParameters?.objectTypeId ?? typeByLocation);
    const viewDefinition = getViewDefintionFromObject({ type: objectTypeId ?? '' });
    const [searchParams] = useTypedSearchParams();
    const { contextObjectSk, adjacencyType, supportedType } = searchParams;
    const contextZombie = contextObjectSk ? getZombieInstanceFromPrimaryKey(contextObjectSk) : undefined;
    const contextObject = contextZombie ?? contextCustomer;
    const searchContextObject = contextObject;
    const viewObject = { matchedPrimary: contextObject, matchedRelatedByPk: [], matchedRelatedBySk: [] };
    const adjacentType = adjacencyType ?? AdjacentType.CHILD;
    debug && console.log('DefaultThingsView constrainedParameters are', { constrainedParameters, contextObject, contextObjectSk });
    const mutatedUserFunctions = {
        ...userFunctions,
        addObjectsToState: (vobs) => {
            debug && console.log(`DefaultThingsView, mutatedUserFunctions captured addObjectsToState `, vobs);
            return userFunctions.addObjectsToState(vobs);
        },
    };
    const maxCols = 6;
    const viewDefinitionColumnVisibility = Object.fromEntries(Object.keys(viewDefinition ?? {})
        .slice(maxCols)
        .map((k) => [k, false]));
    const columnVisibilityReferences = {
        dataTableReference: 'DefaultThingsView',
        objectTypeId,
        viewType: ObjectViewType.List,
        externalColumnVisibility: viewDefinitionColumnVisibility,
    };
    debug && console.log('DefaultThingsView columnVisibility', columnVisibilityReferences);
    const getListerlizerProps = () => {
        let edgeTypeId = undefined;
        let listerlizerProps = undefined;
        if (objectTypeId && contextObject) {
            switch (adjacentType) {
                case AdjacentType.CHILD:
                    edgeTypeId = getChildEdgeTypeId(contextObject.type, objectTypeId);
                    break;
                case AdjacentType.PARENT:
                    edgeTypeId = getChildEdgeTypeId(objectTypeId, contextObject.type);
            }
            debug && console.log('DefaultThingsView getListerlizerProps resolved edgeType to ', { edgeTypeId, contextObject, objectTypeId });
            const edgeFilter = edgeTypeId ? { edgeTypeId } : undefined;
            let filterConfig = undefined;
            if (Object.keys(searchParams).length !== 0) {
                const filters = [];
                if (supportedType)
                    filters.push({ key: 'supportedType', value: supportedType, predicate: ComparisonType.EQUALS });
                if (filters.length > 0)
                    filterConfig = [{ filters, setOperation: LogicalOperatorType.AND }];
            }
            const adjacentFilter = { objectType: objectTypeId, adjacentType, edgeFilter, filterConfig };
            listerlizerProps = {
                contextObject,
                searchRootObject: searchContextObject,
                /** listerlizer will link to viewObject.matchedPrimary */
                viewObject,
                adjacentFilter,
                viewDefinition,
                columnVisibilityReferences,
                userFunctions: mutatedUserFunctions,
                transactionFunctions,
            };
        }
        else {
            debug && console.log('DefaultThingsView getListerlizerProps: No object type or context object');
        }
        debug && console.log(`DefaultThingsView re-made listerlizer props to`, listerlizerProps);
        debug && console.log(`DefaultThingsView inputs`, { objectTypeId, contextObject });
        return listerlizerProps;
    };
    const listerlizerProps = getListerlizerProps();
    debug && console.log('DefaultThingsView v2 rendering Listerlizer with viewObject', listerlizerProps?.viewObject);
    debug &&
        console.log('DefaultThingsView contextCustomer', {
            contextCustomer,
            contextZombie,
            listerLilizerContextObject: listerlizerProps?.contextObject,
            searchContextObject,
        });
    return (_jsxs(_Fragment, { children: [_jsx(ObjectHeader, { vob: contextObject }), debug && (_jsx("div", { style: { color: 'orange' }, children: _jsx("pre", { children: JSON.stringify({
                        contextCustomer: contextCustomer?.name ?? contextCustomer?.sk ?? 'undefined',
                        contextObject: contextObject?.name ?? contextObject?.sk ?? 'undefined',
                        matchedPrimary: viewObject.matchedPrimary?.name ?? viewObject.matchedPrimary?.sk ?? 'undefined',
                        constrainedParameters,
                        adjacentFilter: listerlizerProps?.adjacentFilter,
                    }, undefined, 1) }) })), listerlizerProps && _jsx(ListerlizerAdapter, { ...listerlizerProps, autoQuery: true })] }));
};
export default DefaultThingsView;
